import { useId } from "react";
import PropTypes from "prop-types";
import "./Logo.css";

function Logo({ size = 40, showWordmark = true, theme = "light" }) {
  const gradientId = useId();
  const backgroundId = `${gradientId}-bg`;
  const accentId = `${gradientId}-accent`;

  return (
    <span className={`logo logo--${theme}`}>
      <svg
        className="logo__mark"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        role="img"
        aria-label="XcelerateIT mark"
      >
        <defs>
          <linearGradient id={backgroundId} x1="0%" x2="100%" y1="0%" y2="100%">
            <stop offset="0%" stopColor="#0f172a" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#1e293b" stopOpacity="1" />
          </linearGradient>
          <linearGradient id={gradientId} x1="0%" x2="100%" y1="0%" y2="100%">
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="45%" stopColor="#0ea5e9" />
            <stop offset="100%" stopColor="#22d3ee" />
          </linearGradient>
          <linearGradient id={accentId} x1="0%" x2="100%" y1="0%" y2="100%">
            <stop offset="0%" stopColor="#22d3ee" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#a855f7" stopOpacity="0.95" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="18" fill={`url(#${backgroundId})`} />
        <path
          d="M16 17h12.6l4.5 7.2L37.6 17H50L38.8 33.6 49 47h-12l-7-9.9L23 47H11l11.7-13.5z"
          fill={`url(#${gradientId})`}
        />
        <path
          d="M33.4 27h8.8l9.8 14H45l-5.6-8.3z"
          fill={`url(#${accentId})`}
          opacity="0.9"
        />
      </svg>
      {showWordmark && (
        <span className="logo__text">
          Xcelerate<span className="logo__accent">IT</span>
        </span>
      )}
    </span>
  );
}

Logo.propTypes = {
  size: PropTypes.number,
  showWordmark: PropTypes.bool,
  theme: PropTypes.oneOf(["light", "dark"])
};

export default Logo;
